import { render, staticRenderFns } from "./ActSingleProd.vue?vue&type=template&id=c5082274&scoped=true&"
import script from "./ActSingleProd.vue?vue&type=script&lang=js&"
export * from "./ActSingleProd.vue?vue&type=script&lang=js&"
import style0 from "./ActSingleProd.vue?vue&type=style&index=0&id=c5082274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5082274",
  null
  
)

export default component.exports